import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { NestApiProvider } from "../../nest-api";
import { ResponseDeleteEdutitleDto } from '../dto/edutitle.dto';
import { RequestAddUpdateDelEdutitle, ResponseAddAndUpdateEdutitleDto, ResponseEdutitleAllDto } from './../dto/edutitle.dto';

@Injectable()
export class EdutitleApi {

  private service: string = '';
  private model: string = 'edutitle';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public edutitle1Listing(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getAllEdutitle1';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public edutitle1Detail(payload: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getEdutitle1';
    const params: any = { payload };
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public edutitle2Listing(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getAllEdutitle2';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public edutitle2Detail(payload: any): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getEdutitle2';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

  public delEdutitle1(data: ResponseEdutitleAllDto): Observable<ResponseDeleteEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'deleteEdutitle1';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteEdutitleDto>(method, url, params, urlParams, body);
  }

  public addEdutitle1(data: RequestAddUpdateDelEdutitle): Observable<ResponseAddAndUpdateEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'createEdutitle1';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateEdutitleDto>(method, url, params, urlParams, body);
  }

  public updateEdutitle1(data: RequestAddUpdateDelEdutitle): Observable<ResponseAddAndUpdateEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'updateEdutitle1';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateEdutitleDto>(method, url, params, urlParams, body);
  }

  public delEdutitle2(data: ResponseEdutitleAllDto): Observable<ResponseDeleteEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'deleteEdutitle2';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteEdutitleDto>(method, url, params, urlParams, body);
  }

  public addEdutitle2(data: RequestAddUpdateDelEdutitle): Observable<ResponseAddAndUpdateEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'createEdutitle2';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateEdutitleDto>(method, url, params, urlParams, body);
  }

  public updateEdutitle2(data: RequestAddUpdateDelEdutitle): Observable<ResponseAddAndUpdateEdutitleDto> {
    const method: string = 'POST';
    const func: string = 'updateEdutitle2';
    const params: any = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseAddAndUpdateEdutitleDto>(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/edutitle.api.ts